export default {
    params: ['originalValue', 'fieldName'],
    validate(value, { originalValue, fieldName }) {
        // Remove dashes for comparison
        const normalizedValue = value ? value.replace(/-/g, '') : '';
        const normalizedOriginal = originalValue ? originalValue.replace(/-/g, '') : '';
        
        if (normalizedValue === normalizedOriginal) {
            return true;
        }
        
        return `The re-entered ${fieldName} does not match the ${fieldName}.`;
    }
};
